<template>
  <div>
    <project-table :operateColumns="operateColumns" :extraQuery="extraQuery" :extraSearch="extraSearch" multipleArea>
      <span slot="extraBtn">
        <Button type="primary" style="margin-left: 10px" @click="showReserchForm=true">档案调研申请表</Button>
        <Button type="success" style="margin-left: 10px" @click="reportVisible=true">投标资料一览</Button>
      </span>
    </project-table>
    <!-- 资料移交/接交登记弹窗 -->
    <Modal v-model="isShow" width="650" title="资料移交/接交登记" :transfer="false">
      <div>
        <Row>
          <Col span="3" offset="1" class="modal-label">项目名称:</Col>
          <Col span="18" class="modal-value">
              {{ currentProject.projectName }}
          </Col>
        </Row>
        <Row>
          <Col span="3" offset="1" class="modal-label">存档数量:</Col>
          <Col span="18" class="modal-value">
            <Table size="small" :columns="columns" :data="data1"></Table>
          </Col>
        </Row>
        <Row>
          <Col span="3" offset="1" class="modal-label" style="line-height: 32px;">移交人:</Col>
          <Col span="3" class="modal-value">
            <Input readonly :value="data1[0].transferPerson"></Input>
          </Col>
          <Col span="3" offset="1" class="modal-label" style="line-height: 32px;">移交时间:</Col>
          <Col span="7" class="modal-value">
            <DatePicker
              readonly
              type="datetime" 
              style="width:180px" 
              format="yyyy-MM-dd HH:mm" 
              v-model="data1[0].transferDate"
              >
            </DatePicker>
          </Col>
          <Col span="3" offset="1" class="modal-label">
          <Tooltip placement="top-start">
            <Button type="primary" @click="modal1 = true;currentState='handed'" :disabled="data1[0].transferDate !== ''">移交登记</Button>
            <div slot="content">
                <p>如需特殊修改，请</p>
                <p>联系档案管理员！</p>
            </div>
          </Tooltip>
          </Col>
        </Row>
        <Row>
          <Col span="3" offset="1" class="modal-label" style="line-height: 32px;">接交人:</Col>
          <Col span="3" class="modal-value">
            <Input readonly :value="data1[0].receivePerson"></Input>
          </Col>
          <Col span="3" offset="1" class="modal-label" style="line-height: 32px;">接交时间:</Col>
          <Col span="7" class="modal-value">
            <DatePicker
              readonly
              type="datetime" 
              style="width:180px" 
              format="yyyy-MM-dd HH:mm" 
              v-model="data1[0].receiveDate"
              >
            </DatePicker>
          </Col>
          <Col span="3" offset="1" class="modal-label">
            <Tooltip placement="top-start">
              <Button type="primary" @click="modal2 = true;currentState='handover'" :disabled="data1[0].receiveDate !== ''">接交登记</Button>
              <div slot="content">
                  <p>如需特殊修改，请</p>
                  <p>联系档案管理员！</p>
              </div>
            </Tooltip>
          </Col>
        </Row>
        <Row>
          <Col span="3" offset="1" class="modal-label">备注:</Col>
          <Col span="18" class="modal-value">
            <Input :value="data1[0].transferRemark" readonly type="textarea" :rows="4"></Input>
          </Col>
        </Row>
        <Row>
          <Col span="3" offset="1" class="modal-label" style="line-height: 32px;">修正记录:</Col>
          <Col span="18" class="modal-value">
            <Button type="ghost" @click="showRecord">查看记录</Button>
          </Col>
        </Row>
      </div>
      <div slot="footer" style="text-align: center;">
        <Button type="error" @click="correctModal=true">修正</Button>
        <Button type="ghost" @click="isShow = false">关闭</Button>
      </div>
    </Modal>
    <!-- 移交登记弹窗 -->
    <Modal v-model="modal1" width="452" title="移交登记">
      <div>
        <Form ref="formValidate1" :model="formValidate1" :rules="ruleValidate1" :label-width="100">
          <FormItem label="正本：" prop="originalCount">
            <Input v-model="formValidate1.originalCount" style="width: 90px;"></Input>
            <span style="margin-left: 20px;">(本)</span>
          </FormItem>
          <FormItem label="副本：" prop="copyCount">
            <Input v-model="formValidate1.copyCount" style="width: 90px;"></Input>
            <span style="margin-left: 20px;">(本)</span>
          </FormItem>
          <FormItem label="电子介质：" prop="electronicMedium">
            <Input v-model="formValidate1.electronicMedium" style="width: 90px;"></Input>
            <span style="margin: 0 20px;">(本)</span>
            <Poptip trigger="hover" placement="top-start">
              <Icon type="ios-information-outline" style="font-size: 16px;"></Icon>
              <div slot="content">
                如无，请输入“0”
              </div>
            </Poptip>
          </FormItem>
          <FormItem label="移交人：" prop="transferPerson">
            <Input v-model="formValidate1.transferPerson" style="width: 250px;"></Input>
          </FormItem>
          <FormItem label="移交时间:" prop="transferDate">
            <DatePicker
              type="datetime" 
              style="width:250px;" 
              format="yyyy-MM-dd HH:mm" 
              v-model="formValidate1.transferDate"
              >
            </DatePicker>
          </FormItem>
          <FormItem label="备注：" prop="transferRemark">
            <Input v-model="formValidate1.transferRemark" type="textarea" :rows="4" style="width: 250px;"></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" style="text-align: center;">
        <Button type="primary" @click="confirm('formValidate1')">提交</Button>
        <Button type="ghost" @click="modal1 = false">取消</Button>
      </div>
    </Modal>
    <!-- 接交登记弹窗 -->
    <Modal v-model="modal2" width="428" title="接交登记" :styles="{top: '170px'}">
      <div>
        <Form ref="formValidate2" :model="formValidate2" :rules="ruleValidate2" :label-width="100">
          <FormItem label="装箱箱号：" prop="packageNumber">
            <Input v-model="formValidate2.packageNumber" style="width: 150px;" readonly></Input>
            <Button type="primary" style="margin-left: 20px;" :disabled="!!this.formValidate2.packageNumber" @click="getPackageNumber">点击生成</Button>
          </FormItem>
          <FormItem label="封箱数量：" prop="packageCount">
            <InputNumber :min="0" v-model="formValidate2.packageCount" :formatter="value => Math.round(value)" style="width: 250px;"></InputNumber>
          </FormItem>
          <FormItem label="接交人：" prop="receivePerson">
            <Input v-model="formValidate2.receivePerson" style="width: 250px;"></Input>
          </FormItem>
          <FormItem label="接交时间:" pros="receiveDate" class="ivu-form-item-required">
            <DatePicker 
              type="datetime" 
              style="width:250px;" 
              format="yyyy-MM-dd HH:mm" 
              v-model="formValidate2.receiveDate"
              >
            </DatePicker>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" style="text-align: center;">
        <Button type="primary" @click="confirm('formValidate2')">提交</Button>
        <Button type="ghost" @click="modal2 = false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modal3" title="温馨提示" :styles="{top: '250px'}">
      <p style="font-size: 14px;">提交后登记内容不可修改，请确认是否正确填写！</p>
      <div slot="footer">
        <Button type="ghost" @click="modal3 = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
    <!-- 修正记录 -->
    <Modal v-model="correctModal" width="200" title="请选择要修正的内容：" class-name="modal" :transfer="false">
      <Button type="primary" style="display:block;margin:10px auto 0" @click="correct('modal1')" :disabled="data1[0].receiveDate === ''">
        修正移交登记
      </Button>
      <Button type="primary" style="display:block;margin:20px auto 0" @click="correct('modal2')" :disabled="data1[0].receiveDate === ''">
        修正接交登记
      </Button>
      <div slot="footer" style="display: none;"></div>
    </Modal>
    <Modal v-model="modal4" width="420" title="查看修正记录">
      <div style="text-align:center">
        <Table :columns="recordCol" :data="recordList" size="small"></Table>
        <Page :total="recordList.length" size="small" :page-size="5" style="margin-top: 15px;"></Page>
      </div>
      <div slot="footer" style="display: none;">
      </div>
    </Modal>
    <!-- 报表 -->
    <Modal v-model="reportVisible" title="投标资料一览" width="88%">
      <iframe :src="reportUrl" style="width:100%;height:500px;border:0"></iframe>
      <div slot="footer"></div>
    </Modal>
    <!-- 档案调阅申请表 -->
    <Modal v-model="showReserchForm" title="档案调阅申请表" width="680">
      <research-form ref="form" :projectList="projectList" @startFlow="startFlow"></research-form>
      <div slot="footer" style="text-align:center">
        <Button @click="$refs.form.validFrom()" type="primary">提交</Button>
        <Button @click="showReserchForm=false">取消</Button>
      </div>
    </Modal>
    <!-- 流程人员选择 -->
    <Modal title="流程人员选择" v-model="peopleDialogVisible" width="700px" id="peopleDialog" :mask-closable="false">
			<PeopleSel :child-msg="peopleObj" @toparentevent="(e)=>{chosedPeopleObj=e}"></PeopleSel>
			<div slot="footer" class="dialog-footer">
				<Button v-if="peopleObj.NextActivityName != '结束'" type="primary" @click="handlePeopleClick(1)">下一步</Button>
				<Button v-else type="primary" @click="handlePeopleClick(0)">结 束</Button>
				<Button type="primary" @click="peopleDialogVisible = false">关 闭</Button>
			</div>
			<Spin fix v-if="endflowSpin">正在处理，请稍候..</Spin>
		</Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
import requestUrls from '@/lib/requestUrls'
import ProjectTable from '@/components/projectTable'
import researchForm from './researchForm'
import { getProjectPermission } from "@/lib/projectPermission"
import { formatDate } from "@/lib/tool"
import qs from "qs"
import PeopleSel from "@/components/workflow/peopleSelect"
import { GetTodoList } from '@/lib/flow'

export default {
  components: {
    ProjectTable,
    researchForm,
    PeopleSel
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'));
      } else {
        callback()
      }
    }
    return {
      wfUrl: 'http://qy.chinapsp.cn:45100',
      operateColumns: [
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Spin.show()
                    this.currentProject = params.row
                    // 获取投标档案存档记录
                    ajax.get(requestUrls.CLBidFile.GetPaged, {
                      params: {
                        filter: `projectId == ${params.row.id}`
                      }
                    }).then(res => {
                      if (res.data.result.totalCount) this.data1 = res.data.result.items
                      this.isShow = true
                      this.$Spin.hide()
                    })
                  }
                }
              }, '移交/接交投标资料')
            ])
          }
        }
      ],
      projectList: [],
      permission: {
        type: ' and type=="开评标" and roomId >= "0"',
      },
      extraQuery: {
        status: ' and (projectState.Contains("已开评标完") or projectState.Contains("项目失败") or projectState.Contains("项目结项"))'
      },
      extraSearch: {
        moreSearch: true
      },
      isShow: false,
      currentProject: {},
      columns: [
        {
          title: '正本(本)',
          key: 'originalCount',
          width: 100
        },
        {
          title: '副本(本)',
          key: 'copyCount',
          width: 100
        },
        {
          title: '电子介质(本)',
          key: 'electronicMedium',
          width: 120
        },
        {
          title: '装箱箱号',
          key: 'packageNumber',
          // width: 150
        }
      ],
      data1: [{
        originalCount: '/',
        copyCount: '/',
        electronicMedium: '/',
        packageNumber: '',
        transferPerson: '',
        transferDate: '',
        receivePerson: '',
        receiveDate: '',
        transferRemark: ''
      }],
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      formValidate1: {
        originalCount: '',
        copyCount: '',
        electronicMedium: '',
        transferPerson: '',
        transferDate: '',
        transferRemark: ''
      },
      ruleValidate1: {
        originalCount: [
          { required: true, message: '请输入正本', trigger: 'blur' }
        ],
        copyCount: [
          { required: true, message: '请输入副本', trigger: 'blur' },
        ],
        electronicMedium: [
          { required: true, message: '请输入电子介质', trigger: 'blur' }
        ],
        transferPerson: [
          { required: true, message: '请输入移交人', trigger: 'blur' }
        ],
        transferDate: [
          { required: true, type: 'date', message: '请选择移交时间', trigger: 'change' }
        ]
      },
      formValidate2: {
        packageNumber: '',
        packageCount: 1,
        receivePerson: this.$store.state.session.user.name,
        receiveDate: formatDate()
      },
      ruleValidate2: {
        packageNumber: [
          { required: true, message: '请生成装箱箱号', trigger: 'blur' }
        ],
        packageCount: [
          { required: true, message: '请输入封箱数量', trigger: 'blur', type: 'number' },
        ],
        receivePerson: [
          { required: true, message: '请输入接交人', trigger: 'blur' }
        ],
        receiveDate: [
          { required: true, type: 'date', message: '请选择接交时间', trigger: 'blur' }
        ]
      },
      currentState: 'handed',
      recordCol: [
        {
          title: '序号',
          key: 'index',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h('span', params.index + 1)
          }
        },
        {
          title: '修改时间',
          key: 'creationTime',
          align: 'center',
          render: (h, params) => {
            return h('span', formatDate(params.row.creationTime))
          }
        },
        {
          title: '修正类型',
          key: 'correctType',
          align: 'center',
          render: (h, params) => {
            let correctType = params.row.correctType === '1' ? '移交修改' : params.row.correctType === '2' ? '接交修改' : ''
            return h('span', correctType)
          }
        },
        {
          title: '操作人',
          key: 'correctMember',
          align: 'center',
          width: 120
        }
      ],
      recordList: [],
      correctModal: false,
      correctType: '',
      reportVisible: false,
      reportUrl: 'http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/档案管理/投标资料归档登记表.cpt',
      showReserchForm: false,
      peopleDialogVisible: false,
      peopleObj: {}, //选人子组件通信
      chosedPeopleObj: {}, //选人子组件返回
      endflowSpin: false,
      formData: {},
      title: ''
    }
  },
  watch: {
    isShow (val) {
      if (!val) {
        this.data1 = [{
          originalCount: '/',
          copyCount: '/',
          electronicMedium: '/',
          packageNumber: '',
          transferPerson: '',
          transferDate: '',
          receivePerson: '',
          receiveDate: '',
          transferRemark: ''
        }]
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.session.user
    }
  },
  methods: {
    log () {
      console.log('99999999')
    },
    confirm (name) {
      this.$refs[name].validate((valid) => {
        if (valid) this.modal3 = true
      })
    },
    async submit () {
      let clBidFile = {
        projectId: this.currentProject.id,
        projectName: this.currentProject.name,
        projectShort: this.currentProject.projectShort,
        projectFull: this.currentProject.projectFull,
        area: this.currentProject.district,
        openBidDate: this.currentProject.clMeetingRoom.beginTime
      }
      if (this.currentState === 'handed') {
        this.formValidate1.transferDate = formatDate(this.formValidate1.transferDate)
        clBidFile = Object.assign(clBidFile, this.formValidate1)
        if (this.data1.length) clBidFile = Object.assign(this.data1[0], this.formValidate1)
      }
      if (this.currentState === 'handover') {
        this.formValidate2.receiveDate = formatDate(this.formValidate2.receiveDate)
        clBidFile = Object.assign(clBidFile, this.formValidate2)
        if (this.data1.length) clBidFile = Object.assign(this.data1[0], this.formValidate2)
      }
      ajax.post(requestUrls.CLBidFile.CreateOrUpdate, {
        clBidFile
      }).then(res => {
        if (res.data.success) {
          if (this.correctModal) { // 创建修正记录
            ajax.post(requestUrls.CLBidFile.CreateRecord, {
              bidFileId: res.data.result.id,
              correctMember: this.$store.state.session.user.name,
              correctType: this.correctType
            }).then(res => {
              this.correctModal = false
            })
          }
          this.$Message.success('提交成功')
          this.modal1 = false
          this.modal2 = false
          this.modal3 = false
        }
      })
    },
    getPackageNumber () {
      ajax.post(requestUrls.CLBidFile.PostPackageNumber, {
        openBidDate : this.currentProject.clMeetingRoom.beginTime.replace('T', ' '),
        area: '广州'
      }).then(res => {
        this.formValidate2.packageNumber = res.data.result
      })
    },
    correct (type) {
      this[type] = true
      this.correctType = type.substr(-1)
      if (type === 'modal1') this.formValidate1 = this.data1[0]
      if (type === 'modal2') this.formValidate2 = this.data1[0]
    },
    showRecord () {
      this.$Spin.show()
      ajax.get(requestUrls.CLBidFile.GetRecordPaged, {
        params: {
          bidFileId: this.data1[0].id
        }
      }).then(res => {
        this.$Spin.hide()
        this.modal4 = true
        this.recordList = res.data.result.items
      })
    },
    startFlow (param, title) {
      // let processVariablesJson = JSON.stringify([{ key: 'status', value: self.$refs[this.refType].xmlObj.category.projectnature }])
      this.formData = param
      this.title = title
      this.$Spin.show()
      ajax({
        method: "post",
        url: this.wfUrl + "/WorkflowBusinessRESTfullApi/GetActivityInfoIUsers",
        data: qs.stringify({
						authorJson: JSON.stringify({
							"loginAccount": this.userInfo.phoneNumber
						}),
						parmJson: JSON.stringify({
							"appId": 'DY',
							"taskId": "",
							"processVariablesJson": ''
						})
					})
      }).then(res => {
        this.$Spin.hide()
        this.peopleObj = res.data[0]
        this.peopleDialogVisible = true
      })
    },
    handlePeopleClick (num) {
      if ((!!this.chosedPeopleObj.userId && num == 1) || num == 0) {
        // 新建发起
        this.$Spin.show()
        ajax({
          method: "post",
          url: this.wfUrl + "/WorkflowBusinessRESTfullApi/StartWorkflow/",
          data: qs.stringify({
            "authorJson": JSON.stringify({
              "loginAccount": this.userInfo.phoneNumber
            }),
            "parmJson": JSON.stringify({
              "appId": 'DY',
              "wiid": this.formData.flowId,
              "businessKey": JSON.stringify({
                isReturn: this.formData.isReturn,
                remark: this.formData.isReturn === '是' ? this.formData.expectReturnDate : this.formData.notReturnReason
              }), // 记录是否归还
              "title": this.title,
              "opinion": "流程发起",
              "toUserNameOrId": "",//用途不明
              "toActivityList": "{'" + this.peopleObj.NextActivityCode + "':'" + this.chosedPeopleObj.userId + "'}",
              "processVariablesJson": ""//用途不明
            }),
          })
        }).then((res) => {
          if (res.status == 200) {
            // this.$set(this.formData, 'flowId', flowId)
            ajax.post(requestUrls.CLShiftingFile.CreateOrUpdate, {
              clShiftingFile: this.formData
            }).then(res => {
              this.$Spin.hide()
              this.$Message.success('提交成功！')
              this.showReserchForm = false
              this.peopleDialogVisible = false
            })
          }
        })
      } else {
        this.$Message.error("未选择审核人员")
      }
    }
  }
}
</script>

<style lang="less">
.modal {
  .ivu-modal {
    top: 180px;
  }
}
.eva-modal {
  .ivu-modal {
    top: 0;
    height: 100%;
  }
  .ivu-modal-content {
    height: 100%;
  }
  .ivu-modal-body {
    height: 90%;
  }
}
.modal-label {
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  padding-right: 10px;
}
.modal-value {
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
